import Reactotron from 'reactotron-react-js';

declare global {
	interface Console {
		tron: any;
	}
}

console.tron = Reactotron;

Reactotron.configure().connect();
